import { Button, Grid } from "@mui/material";
import { contactApiKeyStore } from "../../../../api/contact-api-key-store";
import { SiTrackGrid } from "../../../../components/si-track-grid/si-track-grid";
import { GridColumnConfig } from "../../../../models/gridCoumnConfig";
import { UserPermissionName } from "../../../../models/user-permission-name";
import { usersApiKeyStore } from "../../../../api/users-api-key-store";
import React, { useState } from "react";
import { useSaveData } from "../../../../hooks/useSaveData";
import { workOrdersApiKeyStore } from "../../../../api/workorders-api-key-store";

const columns: GridColumnConfig[] = [
    {
        title: 'Inspector Name',
        field: 'fullName',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Email',
        field: 'email',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Cell Phone',
        field: 'mobile',
        filter: 'text',
        searchable: true,
    },
    {
        title: 'Option',
        field: 'option',
        filter: 'text',
        width: '155',
        searchable: false,
        isGroupable: false,
        isHideColumnMenu: true
    },
];

interface CellProps {
    inspectorData: any;
    workOrderID: any;
}

interface CustomGridCellProps {
    field: string;
}

interface DuxInspectorsComponent {
    workOrderID: any;
    onDuxCall: () => void;
    onClosed: () => void;
}
export const DuxInspectorsComponent = ({ workOrderID, onDuxCall, onClosed }: DuxInspectorsComponent) => {

    const { isLoading, mutateAsync } = useSaveData(workOrdersApiKeyStore.workOrderDuxSMS(),
        () => usersApiKeyStore.getUsersByRole('ins'));
    const handleSendDuxSms = async (userID: any, workOrderID: any) => {
        const data = {
            inspectorID: userID,
            workOrderID: workOrderID,
        };
        const smsResponse = await mutateAsync({ data: data });
        // Cast data to any to silence TS errors for dynamic keys
        const responseData: any = smsResponse?.data;
        const duxAdHocCallGuid = responseData?.duxAdHocCallGuid;
        const returnedWorkOrderID = responseData?.workOrderID;
        // Call Azure Function with query params if both values exist
        try {
            const functionUrl = process.env.REACT_APP_DUX_ADHOC_CALL_URL;
            if (functionUrl && duxAdHocCallGuid && returnedWorkOrderID) {
                const url = `${functionUrl}&DuxAdHocCallGuid=${encodeURIComponent(duxAdHocCallGuid)}&WorkOrderID=${encodeURIComponent(returnedWorkOrderID)}`;
                await fetch(url, { method: 'POST' });
            }
        } catch (err) {
            console.error('Azure Function call failed', err);
        }
        onDuxCall();
    };

    const EditCell = React.memo(({ inspectorData, workOrderID }: CellProps) => {
        const [hovered, setHovered] = useState(false);
        const handleMouseOver = () => {
            setHovered(true);
        };
        const handleMouseOut = () => {
            setHovered(false);
        };

        const buttonStyle = {
            color: 'white',
            backgroundColor: hovered ? '#0000b5' : '#0000b5',
            padding: '8px',
            maxHeight: '28px',
        };

        return (
            <td className="stickyCloumn">
                <div className="actionWidth">
                    <Button
                        onClick={() => handleSendDuxSms(inspectorData?.dataItem?.userID, workOrderID)}
                        className="btn btn-primary btn-sm sitDefaultBtn"
                        style={buttonStyle}
                        onMouseOver={handleMouseOver}
                        onMouseOut={handleMouseOut}
                    >
                        SEND DUX SMS
                    </Button>
                </div>
            </td>
        );
    });

    const customGridCell = ({ field }: CustomGridCellProps): ((dataItem: any) => JSX.Element) | undefined => {
        if (field === 'option') {
            return (dataItem: any) => {
                return <EditCell inspectorData={dataItem} workOrderID={workOrderID} />;
            };
        }
        // Return undefined if the field is not 'bluePrint'
        return undefined;
    };

    return (
        <Grid container spacing={2}>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <SiTrackGrid
                    fileTitle='schedule_dux_inspectors'
                    dataItemKey="userID"
                    columns={columns}
                    currentPageSize={10}
                    customCell={(field) =>
                        customGridCell?.({
                            field,
                        })
                    }
                    queryConfig={usersApiKeyStore.getUsersByRole('ins')}
                    actionPermissions={{
                        export: UserPermissionName.DOWNLOAD_GRID,
                    }}
                    isBusy={isLoading}
                />
            </Grid>
            <Grid item lg={12} sm={12} xl={12} xs={12}>
                <Button variant="outlined" onClick={onClosed} style={{ width: '130px' }}>
                    {' '}
                    Cancel
                </Button>
            </Grid>
        </Grid>
    );
}